<template>
  <el-container class="ServiceCollect">
    <el-main>
      <ATable
        ref="table"
        hide-pagination
        :data="items"
        hide-top-panel
        hide-button-insert
        @cell-click="handleCellClick"
      >
        <el-table-column
          type="index"
          label="No"
          align="center"
          prop="index"
          :width="$width.index"
          :index="handleIndex"
        />
        <el-table-column label="결제일" prop="collect_date" width="150">
          <template slot-scope="scope">
            <ADatePicker
              v-model="scope.row.collect_date"
              v-bind:class="{ 'readonly-noborder': scope.row.id !== editingId }"
              :readonly="scope.row.id !== editingId"
              :placeholder="$t('message.choose_date')"
              :clearable="false"
            />
          </template>
        </el-table-column>
        <el-table-column label="수금방법" prop="collect_way_flag" width="140">
          <template slot-scope="scope">
            <div v-if="scope.row.id === editingId">
              <el-select
                v-model="scope.row.collect_way_flag_temp"
                v-bind:class="{
                  'readonly-noborder': scope.row.id !== editingId,
                }"
                @change="handleChangeCollectWayFlag(scope.row)"
              >
                <el-option
                  v-for="item in pay_way_flag_options"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                />
              </el-select>
            </div>
            <div v-else>
              {{ resolveCollectWay(scope.row) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="수금액" prop="price" width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.id === editingId">
              <ANumberInput
                v-model="scope.row.price"
                v-bind:class="{
                  'readonly-noborder': scope.row.id !== editingId,
                }"
                :readonly="scope.row.id !== editingId"
              />
            </div>
            <div v-else>
              {{ scope.row.price }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="할인액" prop="discount_price" width="100">
          <template slot-scope="scope">
            <ANumberInput
              v-model="scope.row.discount_price"
              v-bind:class="{ 'readonly-noborder': scope.row.id !== editingId }"
              :readonly="scope.row.id !== editingId"
            />
          </template>
        </el-table-column>
        <el-table-column label="비고" prop="desc">
          <template slot-scope="scope">
            <el-input
              size="mini"
              :readonly="scope.row.id !== editingId"
              v-bind:class="{ 'readonly-noborder': scope.row.id !== editingId }"
              v-model="scope.row.desc"
            />
          </template>
        </el-table-column>
        <el-table-column label="명령" width="150">
          <template slot-scope="scope">
            <div v-show="scope.row.id === editingId">
              <el-button
                type="primary"
                size="mini"
                :disabled="!has_grant_write"
                @click="handleClickRegister(scope.row)"
                >저장</el-button
              >
              <el-button size="mini" @click="calcelEditing(scope.row)"
                >취소</el-button
              >
            </div>
            <div v-show="scope.row.id !== editingId">
              <el-button
                type="danger"
                size="mini"
                @click="handleClickDelete(scope.row)"
                >삭제</el-button
              >
            </div>
          </template>
        </el-table-column>
      </ATable>
    </el-main>
    <el-footer>
      <el-button
        type="primary"
        v-shortkey="['f2']"
        @shortkey.native="handleClickedCreate"
        @click="handleClickedCreate"
        >추가 (F2)</el-button
      >
      <el-button class="right" @click="handleClickClose"
        >{{ $t("button.close") }}(Esc)</el-button
      >
    </el-footer>
  </el-container>
</template>

<script>
import { form } from "@/common/mixins/form";
import { account_form } from "@/common/mixins/account_form";

export default {
  name: "ServiceCollect",
  mixins: [form, account_form],
  data() {
    return {
      title: this.$t("title.collection"),
      items: [],
      editingId: -1,
      oldItem: undefined,
      deleteData: undefined,
    };
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    contract: {
      type: Object,
      required: true,
    },
    has_grant_write: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.init();
  },
  destroyed() {
    if (this.editingId < 0) {
      return;
    }
    this.calcelEditing(this.oldItem);
    this.editingId = -1;
  },
  computed: {
    pay_way_flag_options: function() {
      let pay_way_flag_list = this.system.options.pay_way_flag.filter((p) =>
        ["1", "3"].includes(p.value)
      );
      // deep copy
      let collect_list = JSON.parse(JSON.stringify(pay_way_flag_list));
      return this.convert_bankbook_options(collect_list, 1);
    },
  },
  methods: {
    init() {
      this.api.listCollectService(this.data.id).then((res) => {
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.items = res.data;
        // 통장관련 아이템 이름 재설정
        if (this.items.length > 0) {
          this.items.forEach(function(item) {
            if (item.collect_way_flag == "2" && item.account_id != null) {
              let account_method =
                item.collect_way_flag + "-" + item.account_id;
              item.collect_way_flag_temp = account_method;
            } else {
              item.collect_way_flag_temp = item.collect_way_flag;
            }
          });
        }
      });
    },
    getDefaultData() {
      return {
        id: 0,
        customer_id: this.data.customer_id,
        customer_name: this.data.customer_name,
        service_id: this.data.id,
        collect_date: this.util.getDateString(),
        collect_way_flag: "1",
        collect_way_flag_temp: "1",
        price: null,
        discount_price: 0,
        desc: null,
      };
    },
    calcelEditing(data) {
      let index = this.items.findIndex((i) => i.id === data.id);
      if (this.oldItem.id) {
        this.items.splice(index, 1, this.oldItem);
      } else {
        this.items.splice(index, 1);
      }
      this.editingId = -1;
    },
    doDelete() {
      this.api.deleteCollect(this.deleteData).then((res) => {
        let index = this.items.findIndex((i) => i.id === this.deleteData.id);
        this.items.splice(index, 1);
        this.handleResponseCompleted(res, this.$t("message.success_delete"));
      });
    },
    resolveCollectWay(item) {
      let pay_way = this.pay_way_flag_options.find(
        (f) => f.value === item.collect_way_flag_temp
      );
      return pay_way ? pay_way.label : item.collect_way_flag_temp;
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleClickedCreate() {
      if (this.editingId > -1) {
        this.calcelEditing(this.oldItem);
      }
      this.editingId = 0;
      this.oldItem = this.getDefaultData();
      this.items.push(this.oldItem);
    },
    handleCellClick(item, column) {
      if (this.editingId === item.id) {
        return;
      }
      if (this.editingId > -1) {
        this.calcelEditing(this.oldItem);
      }
      if (!column.property) {
        return;
      }
      this.editingId = item.id;
      this.oldItem = Object.assign({}, item);
    },
    handleClickRegister(data) {
      if (!data.price) {
        this.util.notify_warning(this, this.title, "수금액을 입력하세요.");
        return;
      }
      data.customer_id = this.contract.customer_id;
      data.customer_name = this.contract.customer_name;
      data.service_id = this.data.id;
      if (data.id) {
        this.api.updateCollect(data).then((res) => {
          this.handleResponseCompleted(res, this.$t("message.success_update"));
        });
      } else {
        this.api.createCollect(data).then((res) => {
          this.handleResponseCompleted(res, this.$t("message.success_create"));
        });
      }
    },
    handleClickDelete(data) {
      this.deleteData = data;
      this.util.confirm_delete(
        this,
        this.title + "[" + data.price + "]",
        this.doDelete
      );
    },
    handleResponseCompleted(res, successMessage) {
      if (res.error !== this.system.noError) {
        this.util.notify_response_error(this, this.title, res);
        return;
      }
      this.editingId = -1;
      this.util.notify_success(this, this.title, successMessage);
      this.$emit("change");
    },
    handleClickClose() {
      this.$emit("completed");
    },
    handleChangeCollectWayFlag(item) {
      this.onChangeCollectWayFlag(item);
    },
  },
};
</script>
<style lang="scss">
.ServiceCollect {
  .el-table .cell {
    text-align: center;
  }
}
</style>
